import styled from 'styled-components'

export const HeroWrapper = styled.div`
  text-align: left;
  position: relative;

  .hero__bg {
    background-size: 65%;
    background-position: right center;
    background-repeat: no-repeat;
    position: absolute;
    z-index: -9;
    width: 100%;
    height: 100%;
    right: 0;

    ${({ theme }) => theme.breakpoints.down('xs')} {
      background-size: 100%;
      height: 544px;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      background-size: cover;
      height: 406px;
      background-position: right top;
    }
  }

  .heroContent {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
    width: 667px;
    padding: 150px 0 150px 110px;

    ${({ theme }) => theme.breakpoints.down('md')} {
      padding: 100px 0px 100px 40px;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      padding: 564px 32px 0px;
      width: calc(100% - 74px);
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      padding: 426px 16px 0px;
      width: calc(100% - 32px);
    }

    .eyebrow {
      font-size: 16px;
      margin-bottom: 24px;
      font-weight: 700;
      line-height: 20px;
      text-transform: uppercase;
      letter-spacing: normal;
    }

    .subHeading {
      color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
      font-size: 24px;
      ${({ theme }) => theme.breakpoints.down('sm')} {
        font-size: 20px;
      }
    }

    .heroHeading {
      font-size: 56px;
      margin: 0 0 24px 0;
      font-weight: 700;
      line-height: 64px;
      letter-spacing: -2px;

      ${({ theme }) => theme.breakpoints.down('sm')} {
        font-size: 48px;
        line-height: 48px;
      }

      ${({ theme }) => theme.breakpoints.down('xs')} {
        letter-spacing: -1px;
        font-weight: 600;
      }

      ${({ theme }) => theme.breakpoints.down('xs')} {
        font-size: 32px;
        line-height: 40px;
      }
    }

    .heroButtons {
      margin-top: 24px;
      display: flex;

      ${({ theme }) => theme.breakpoints.down('xs')} {
        flex-direction: column;
        width: 100%;
      }

      .CTA:nth-child(2) {
        margin-left: 16px;

        ${({ theme }) => theme.breakpoints.down('xs')} {
          margin-left: 0;
        }
      }

      .CTA {
        ${({ theme }) => theme.breakpoints.down('xs')} {
          margin-bottom: 12px;
          width: 100%;
          justify-content: center;
        }
      }
    }
  }
`

export const TabbingNav = styled.div`
  padding: 0px 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: ${({ theme }) => theme?.webMktNewPalette?.background.light.default};

  ${({ theme }) => theme.breakpoints.down('xs')} {
    padding: 48px 32px;
    width: calc(100% - 64px);
    position: relative;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    flex-direction: column;
  }

  ul {
    list-style: none;
    display: flex;
    padding: 88px 0 48px;
    margin: 0;

    ${({ theme }) => theme.breakpoints.down('xs')} {
      padding: 0;
      flex-direction: column;
    }

    li {
      padding-right: 100px;
      border-top: 4px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
      margin-right: 32px;

      ${({ theme }) => theme.breakpoints.down('sm')} {
        padding-right: 80px;
      }

      ${({ theme }) => theme.breakpoints.down('xs')} {
        padding-right: 30px;
      }

      ${({ theme }) => theme.breakpoints.down('xs')} {
        padding-right: 0px;
        margin-bottom: 16px;
        margin-right: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      :hover {
        border-top: 4px solid ${({ theme }) => theme.webMktNewPalette.black};
      }

      a {
        text-decoration: none;
        color: ${({ theme }) => theme.webMktNewPalette.black};
        display: block;
        padding: 20px 0 0;
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        letter-spacing: -1px;

        ${({ theme }) => theme.breakpoints.down('sm')} {
          font-size: 20px;
          line-height: 24px;
          letter-spacing: normal;
          font-weight: 600;
        }
      }
    }
  }
`
